export const useActionMenuComposable = () => {
  const getTruthyStatefulTitle = (options:{state:boolean,truthyStatefulTitle: string, falsyStatefulTitle: string}) => {
    return options?.state ? options?.truthyStatefulTitle : options?.falsyStatefulTitle;
  };

  return {
    getTruthyStatefulTitle
  };
};